/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInvoiceCreate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v20h10v-2H6V4h7v5h5v5h2V7.586L14.414 2zm11 3.414L16.586 7H15zM12 13H8v-2h4zm4-2v2h-2v-2zm-4 6H8v-2h4zm6 1h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInvoiceCreate as InvoiceCreate };
